export const DEFAULT_PER_PAGE_COUNT = 25;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_ACTIVE_PAGE = 1;
export const SHORT_DATE_FORMAT = 'YYYY-MM-DD';
export const LONG_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const DISPLAY_DATE_FORMAT_DOTS = 'DD.MM.YYYY hh:mm:ss';
export const LONG_DATE_FORMAT_DOTS_24H = 'DD.MM.YYYY HH:mm:ss';
export const TIME_RANGE_WEEK = 7;
export const TIME_RANGE_TWO_WEEKS = 14;
export const TIME_RANGE_1_DAY = 1;
export const TIME_RANGE_3_DAYS = 3;
export const TIME_RANGE_60_MINUTES = 60;
export const TIME_RANGE_0_MINUTES = 0;
export const TIME_RANGE_MONTH = 30;
export const TIME_RANGE_35_DAYS = 35;
export const TIME_RANGE_THREE_MONTHS = 90;
export const TIME_RANGE_SIX_MONTHS = 180;
export const TIME_RANGE_YEAR = 365;
export const ALL_CONTACTS_SEGMENT = 'All Contacts';
export const TIME_RANGES = [
    TIME_RANGE_WEEK,
    TIME_RANGE_TWO_WEEKS,
    TIME_RANGE_MONTH,
    TIME_RANGE_THREE_MONTHS,
    TIME_RANGE_SIX_MONTHS,
    TIME_RANGE_YEAR,
];
export const ACTIVITY_TIME_RANGES = [TIME_RANGE_1_DAY, TIME_RANGE_3_DAYS, TIME_RANGE_WEEK, TIME_RANGE_TWO_WEEKS, TIME_RANGE_35_DAYS];

export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');
export const MINUTES_IN_DAY = 1440;

export const LIMITED_LOGS_DAYS = 3;
export const LIMITED_LOGS_DAYS_PRO = 7;
export const EXTENDED_LOGS_DAYS = 35;
//TODO: As this price is not in account model, for now we store it as const
export const EXTENDED_LOGS_PRICE_PER_DAY = 2;

export const MAX_CHANNELS_LIST_LENGTH = 20;
export const MAX_CHANNELS_LIST_WITH_QUERY_LENGTH = 100;

export const TotalContactHeaders = {
    TotalCount: 'x-total-count',
    ActiveCount: 'x-total-active-count',
    BouncedCount: 'x-total-bounced-count',
    AbuseCount: 'x-total-abuse-count',
    InactiveCount: 'x-total-inactive-count',
    StaleCount: 'x-total-stale-count',
    UnsubscribedCount: 'x-total-unsubscribed-count',
    TransactionalCount: 'x-total-transactional-count',
    EngagedCount: 'x-total-engaged-count',
    NotconfirmedCount: 'x-total-notconfirmed-count',
};

export const EventHeaders = {
    ReadyToSendCount: 'X-ReadyToSend-Count',
    WaitingToRetryCount: 'X-WaitingToRetry-Count',
    SendingCount: 'X-Sending-Count',
    ErrorCount: 'X-Error-Count',
    SentCount: 'X-Sent-Count',
    OpenedCount: 'X-Opened-Count',
    ClickedCount: 'X-Clicked-Count',
    UnsubscribedCount: 'X-Unsubscribed-Count',
    AbuseReportCount: 'X-AbuseReport-Count',
    IgnoreCount: 'X-Ignore-Count',
    SpamCount: 'X-Spam-Count',
    BlackListedCount: 'X-BlackListed-Count',
    NoMailboxCount: 'X-NoMailbox-Count',
    GreyListedCount: 'X-GreyListed-Count',
    ThrottledCount: 'X-Throttled-Count',
    TimeoutCount: 'X-Timeout-Count',
    ConnectionProblemCount: 'X-ConnectionProblem-Count',
    SPFProblemCount: 'X-SPFProblem-Count',
    AccountProblemCount: 'X-AccountProblem-Count',
    DNSProblemCount: 'X-DNSProblem-Count',
    NotDeliveredCancelledCount: 'X-NotDeliveredCancelled-Count',
    CodeErrorCount: 'X-CodeError-Count',
    ManualCancelCount: 'X-ManualCancel-Count',
    ConnectionTerminatedCount: 'X-ConnectionTerminated-Count',
    NotDeliveredCount: 'X-NotDelivered-Count',
};

export const SoftHeaders = {
    SoftGreyListedCount: 'X-Soft-GreyListed-Count',
    SoftThrottledCount: 'X-Soft-Throttled-Count',
    SoftTimeoutCount: 'X-Soft-Timeout-Count',
    SoftConnectionProblemCount: 'X-Soft-ConnectionProblem-Count',
    SoftSPFProblemCount: 'X-Soft-SPFProblem-Count',
    SoftDNSProblemCount: 'X-Soft-DNSProblem-Count',
    SoftCodeError: 'X-Soft-CodeError-Count',
    SoftConnectionTerminatedCount: 'X-Soft-ConnectionTerminated-Count',
};

export const HardEventHeaders = {
    IgnoreCount: 'X-Hard-Ignore-Count',
    SpamCount: 'X-Hard-Spam-Count',
    BlackListedCount: 'X-Hard-BlackListed-Count',
    NoMailboxCount: 'X-Hard-NoMailbox-Count',
    AccountProblemCount: 'X-Hard-AccountProblem-Count',
    NotDeliveredCancelledCount: 'X-Hard-NotDeliveredCancelled-Count',
    ManualCancelCount: 'X-Hard-ManualCancel-Count',
    NotDeliveredCount: 'X-Hard-NotDelivered-Count',
};

export const TotalEventHeaders = {
    TotalCount: 'x-total-count',
    ActiveCount: 'x-total-active-count',
    SendingCount: 'x-total-sending-count',
    DeletedCount: 'x-total-deleted-count',
    CompletedCount: 'x-total-completed-count',
    PausedCount: 'x-total-paused-count',
    CancelledCount: 'x-total-cancelled-count',
    ErrorCount: 'x-total-error-count',
    SentCount: 'x-total-sent-count',
    GreylistedCount: 'x-total-greylisted-count',
    IgnoreCount: 'x-total-ignore-count',
    OpenedCount: 'x-total-opened-count',
    ClickedCount: 'x-total-clicked-count',
    AbuseReportCount: 'x-total-abuseReport-count',
    UnsubscribedCount: 'x-total-unsubscribed-count',
    ReadytosendCount: 'x-total-readytosend-count',
    AllCount: 'x-total-all-count',
    WaitingtoretryCount: 'x-total-waitingtoretry-count',
    DraftCount: 'x-total-draft-count',
    UnknownCount: 'x-total-unknown-count',
    AccountproblemCount: 'x-total-accountproblem-count',
    BlacklistedCount: 'x-total-blacklisted-count',
    CodeerrorCount: 'x-total-codeerror-count',
    ConnectionproblemCount: 'x-total-connectionproblem-count',
    ConnectionterminatedCount: 'x-total-connectionterminated-count',
    DnsproblemCount: 'x-total-dnsproblem-count',
    ManualcancelCount: 'x-total-manualcancel-count',
    NomailboxCount: 'x-total-nomailbox-count',
    NotdeliveredCount: 'x-total-notdelivered-count',
    NotdeliveredcancelledCount: 'x-total-notdeliveredcancelled-count',
    SpamCount: 'x-total-spam-count',
    SpfproblemCount: 'x-total-spfproblem-count',
    ThrottledCount: 'x-total-throttled-count',
    TimeoutCount: 'x-total-timeout-count',
    Processing: 'x-total-processing-count',
};
